export enum NotificationStatus {
    CREATED = 'CREATED',
    QUEUED = 'QUEUED',
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    READ = 'READ',
    ERRORED = 'ERRORED',
    DIGESTED = 'DIGESTED',
    PROCESSED = 'PROCESSED',
    DROPPED = 'DROPPED',
    DEFERRED = 'DEFERRED',
    BOUNCED = 'BOUNCED',
    ACCEPTED = 'ACCEPTED',
    SCHEDULED = 'SCHEDULED',
    SENDING = 'SENDING',
    UNDELIVERED = 'UNDELIVERED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
}
